import { z } from 'zod'

export const PrimitiveFieldTypeSchema = z.enum([
  'text',
  'number',
  'date',
  'image',
  'enum',
  'boolean',
])
export type PrimitiveFieldType = z.infer<typeof PrimitiveFieldTypeSchema>

export const MeasurementFieldTypeSchema = z.object({
  kind: z.literal('measurement'),
  unit: z.string(),
  precision: z.number().int().nonnegative(),
  tolerance: z.number().nonnegative().optional(),
})

export const RangeFieldTypeSchema = z.object({
  kind: z.literal('range'),
  unitType: z.string(),
})

export const CurrencyFieldTypeSchema = z.object({
  kind: z.literal('currency'),
  iso4217: z.string().length(3),
})

export const LocalizedEnumFieldTypeSchema = z.object({
  kind: z.literal('localized-enum'),
  values: z.array(
    z.object({
      key: z.string(),
      labels: z.record(z.string(), z.string()),
    })
  ),
})

export const FieldTypeSchema = z.union([
  PrimitiveFieldTypeSchema,
  MeasurementFieldTypeSchema,
  RangeFieldTypeSchema,
  CurrencyFieldTypeSchema,
  LocalizedEnumFieldTypeSchema,
])
export type FieldType = z.infer<typeof FieldTypeSchema>

export const FieldSchemaSchema = z.object({
  key: z
    .string()
    .regex(/^[a-zA-Z][a-zA-Z0-9_]*$/, 'key must be a valid identifier'),
  label: z.string(),
  type: FieldTypeSchema,
  category: z.string().optional(),
  unit: z.string().optional(),
  format: z.string().optional(),
  enumValues: z.array(z.string()).optional(),
})
export type FieldSchema = z.infer<typeof FieldSchemaSchema>
